import { call } from "@saas/api-client";
import { Card, ErrorAlert, formatDate, Loading, PageHeader, Table, useAsync } from "@saas/ui";
import { api } from "./api";
import { useTenantNames } from "./useTenantNames";

export function AuditLogPage() {
  const entries = useAsync(() => call(api.GET("/api/audit-log")), []);
  const tenantName = useTenantNames();

  return (
    <>
      <PageHeader title="Audit log" description="Owner-scope actions: tenant lifecycle, administrators, job retries and every explicit look into a tenant's data. Newest first." />
      <Card title="Entries">
        <ErrorAlert error={entries.error} />
        {entries.loading && !entries.data ? (
          <Loading />
        ) : (
          <Table caption={`${entries.data?.length ?? 0} entr${entries.data?.length === 1 ? "y" : "ies"}`} headers={["When", "Who", "Action", "Tenant", "Detail"]}>
            {entries.data?.map((e) => (
              <tr key={e.id}>
                <td>{formatDate(e.occurredAt)}</td>
                <td>{e.actor}</td>
                <td>
                  <code>{e.action}</code>
                </td>
                <td>{tenantName(e.tenantId)}</td>
                <td className="sb-muted">{e.detail}</td>
              </tr>
            ))}
          </Table>
        )}
      </Card>
    </>
  );
}
